{
  "contacts": {
    "all_contacts": "Tous les contacts",
    "all_employees": "Tous les employés",
    "company_type": "Type de société",
    "consent_status": "Statut de consentement",
    "results": "Résultats",
    "add_new_contact": {
      "continue": "Continuer",
      "add_new_contact": "Ajouter un nouveau contact",
      "success": "Vous avez créé avec succès un nouveau contact",
      "first_step_header": "Ajouter un nouveau contact au personne",
      "first_step_header_description": "Ajoutez un nouveau courriel professionnel ou personnel à la personne et nous créons un nouveau contact basé sur celui-ci.",
      "email_already_exist_in_this_person": "Cette adresse e-mail existe déjà dans les dossiers de cette personne. Vérifiez vos contacts archivés si vous ne la voyez pas.",
      "email_already_exist_in_another_person": "Cette adresse e-mail existe déjà dans les dossiers d'une autre personne. Vérifiez vos contacts archivés si vous ne la voyez pas.",
      "i_dont_have_email_for_this_contact": "Je n'ai pas d'email pour ce contact",
      "this_person_already_has_a_contact_with_this_company": "Cette personne a déjà un contact avec cette entreprise.",
      "company_name": "Nom de l'entreprise",
      "switch_back_to_email": "Revenir au courrier électronique",
      "email": "E-mail",
      "job_title": "Titre du poste",
      "add_company_contact": "Ajouter une entreprise",
      "we_detected_this_email_is_a_company_email": "Nous avons détecté que cet e-mail est celui d'une entreprise. Veuillez vérifier les détails",
      "there_was_an_error_validating_the_email": "Il y a eu une erreur lors de la validation de l'e-mail",
      "please_use_a_valid_email_address": "Veuillez utiliser une adresse e-mail valide",
      "are_you_sure_you_want_to_consolidate_these_persons_into_single_person_profile": "Êtes-vous sûr de vouloir consolidater ces personnes dans un seul dossier de personne?",
      "personal_details": "Détails personnels",
      "contacts": "Contacts",
      "review_potential_duplicates_of_the_person": "Vérifier les doublons potentiels de la personne",
      "we_detected_potential_person_duplicate_for_the_email_you_want_to_add": "Nous avons détecté un doublon potentiel pour l'adresse e-mail que vous souhaitez ajouter. Vous pouvez le signaler pour vérification par l'administrateur.",
      "potential_duplicates_have_been_flagged_for_review": "Les doublons potentiels ont été signalés pour vérification.",
      "thanks_for_helping_keep_our_data_clean": "Merci pour l'aide à garder nos données propres. Les utilisateurs administrateurs vérifieront et prendront des actions pour gérer ces enregistrements.",
      "start_consolidating": "Commencer la consolidation",
      "flag_as_duplicates": "Signalé comme doublon",
      "move_email": "Déplacer l'email?",
      "we_might_have_misplaced_the_email": "Ces personnes ne sont pas des doublons, donc nous avons peut-être perdu l'email. Voulez-vous le déplacer vers le dossier actuel?",
      "visit_profile": "Visiter le profil",
      "these_are_not_duplicates": "Ces personnes ne sont pas des doublons"
    }
  },
  "companies": {
    "all_companies": "Toutes les sociétés",
    "incomplete": {
      "table": {
        "headers": {
          "company": "Société",
          "last_interaction_total": "Dernière interaction (Total)",
          "created_at": "Créé le",
          "type": "Type",
          "missing_info": "Informations manquantes",
          "actions": "Actions"
        }
      },
      "actions": {
        "update_company": "Mettre à jour la société",
        "ignore_company": "ignorer la société",
        "edit_company": "modifier la société",
        "export_companies": "Exporter les sociétés"
      },
      "bulk_actions": {
        "ignore": "Ignorer",
        "archive": "Archiver"
      },
      "order_by": "Trier par",
      "update": {
        "modal_title": "Mettre à jour les données de la société",
        "loading": "Chargement de la société",
        "form": {
          "type": "Type",
          "industries": "Industries",
          "street_address": "Adresse postale",
          "city": "Ville",
          "state": "État/Province",
          "postcode": "Code postal",
          "set_primary_location": "Définir comme emplacement principal"
        }
      }
    },
    "duplicate": {
      "table": {
        "headers": {
          "company": "Société",
          "type": "Type",
          "contacts": "Contacts",
          "last_interaction": "Dernière interaction",
          "action": "Action"
        }
      },
      "actions": {
        "merge": "Fusionner",
        "keep_both": "Garder les deux",
        "continue": "Continuer"
      },
      "merge": {
        "modal_title": "Fusionner la société",
        "manual_modal_title": "Fusion manuelle",
        "description": "Nous combinerons les contacts et interactions des deux sociétés. Les notes, tâches et documents de la société non sélectionnée seront définitivement supprimés.",
        "manual_description": "Nous combinerons les contacts et interactions des deux sociétés. Toutes les notes, tâches et documents autres que ceux de la société principale seront définitivement supprimés.",
        "warning": "Les sociétés fusionnées ne peuvent pas être annulées. Veuillez vous assurer de sélectionner la bonne société.",
        "select_main_company": "Veuillez sélectionner la société comme contact principal :",
        "main_company": "Société principale",
        "company_to_merge": "Société à fusionner",
        "type_to_confirm": "Tapez \"{{label}}\" pour confirmer",
        "placeholder_merge": "Tapez pour rechercher la société principale",
        "placeholder_to_merge": "Tapez pour rechercher la société à fusionner",
        "merged_result_preview": "Aperçu du résultat fusionné",
        "placeholder_confirm": "Tapez \"Fusionner\" pour confirmer",
        "continue": "Continuer"
      },
      "keep_both": {
        "button": "Garder les deux !",
        "confirm_title": "Voulez-vous ajouter ces sociétés à la même hiérarchie ?",
        "confirm_content": "En les ajoutant comme hiérarchie, vous les connectez en tant que groupe.",
        "yes": "Oui",
        "no_separate": "Non, les garder séparées"
      },
      "order_by": "Trier par"
    }
  },
  "key_activity": {
    "slide": {
      "aria_label": "diapositive d'activité clé",
      "contacts_involved": "Contacts Impliqués",
      "staff_involved": "Personnel Impliqué",
      "note": "Note",
      "comments": "Commentaires"
    },
    "performance": {
      "current": "Actuel",
      "best": "Meilleur",
      "consecutive": "Consécutif",
      "longest": "Plus Long",
      "weeks": "Semaines",
      "current_tooltip": "Vous avez enregistré {{count}} activités clés ce mois-ci",
      "best_tooltip": "Votre record personnel : {{count}} activités clés en un mois",
      "consecutive_tooltip": "Vous avez enregistré des activités clés hebdomadaires pendant {{count}} semaines",
      "longest_tooltip": "Votre plus longue série : {{count}} semaines"
    },
    "firm_wide": {
      "title": "Entreprise Entière",
      "this_month": "Ce Mois-ci",
      "tooltip": "Total des activités clés dans l'entreprise ce mois-ci"
    },
    "actions": {
      "update_aria_label": "modifier l'activité clé",
      "update_title": "modifier l'activité clé",
      "remove_aria_label": "supprimer l'activité clé",
      "remove_title": "supprimer l'activité clé",
      "log_new_activity": "Enregistrer une nouvelle activité"
    },
    "grid": {
      "loading_aria_label": "chargement des activités clés",
      "load_limit_message": "Il y a plus d'activités clés que celles affichées.",
      "show_less": "afficher moins",
      "show_more": "+{{count}} de plus"
    },
    "filters": {
      "select_employee": "Sélectionner un Employé",
      "select_month_year": "sélectionner le mois et l'année",
      "select_activity_category": "sélectionner la catégorie d'activité",
      "all_employees": "Tous",
      "basic": "Basique",
      "large": "Large"
    },
    "chart": {
      "business_development": "Activité de Développement Commercial",
      "lead_activity": "Activité de Prospection",
      "marketing_activity": "Activité Marketing"
    },
    "categories": {
      "business_development": "Développement Commercial",
      "lead": "Prospection",
      "marketing": "Marketing"
    }
  },
  "mobile_contact_request": {
    "objective_progress": {
      "thanks_for_update": "Merci pour la mise à jour :)"
    },
    "contact_request_page": {
      "thank_you_message": "Merci d'avoir ajouté vos contacts. Vous pouvez maintenant fermer cette fenêtre.",
      "im_done": "J'ai terminé"
    },
    "header": {
      "instruction_text": "Veuillez sélectionner et ajouter vos contacts que vous souhaitez ajouter à la liste \"{{listName}}\". Une fois que vous avez ajouté vos contacts, cliquez sur \"J'ai terminé\"."
    },
    "my_contacts": {
      "my_contacts": "Mes Contacts",
      "company_type": "Type de société",
      "consent_status": "Statut de consentement",
      "no_contacts_message": "Il n'y a aucun contact à afficher ici"
    },
    "bulk_add": {
      "contact_list": "Liste de Contacts",
      "bulk_add_description": "Ajouter des contacts en lot à la liste",
      "adding_in_progress_message": "Le contact est en cours d'ajout. Veuillez actualiser la page pour voir la liste mise à jour.",
      "adding_in_progress_title": "Ajout de Contact en Cours",
      "add_selected": "Ajouter la Sélection"
    },
    "contacts_table": {
      "selected": "sélectionnés",
      "contact": "Contact",
      "company": "Société",
      "location": "Lieu",
      "last_interaction": "Dernière Interaction"
    }
  },
  "meetings": {
    "slide": {
      "aria_label": "diapositive de réunion",
      "add_key_activity": "Ajouter une activité clé",
      "contacts_involved": "Contacts impliqués",
      "staff_involved": "Personnel impliqué",
      "companies": "Entreprises"
    },
    "upcoming": {
      "cancelled": "[Annulé]",
      "with": "Avec :",
      "mark_as_bd_activity": "marquer comme activité de développement commercial",
      "no_meetings_coming_up": "Aucune réunion à venir"
    },
    "recent": {
      "with": "Avec :",
      "mark_as_bd_activity": "marquer comme activité de développement commercial",
      "create_task": "Créer une tâche",
      "create_note": "Créer une note",
      "no_recent_meetings": "Vous n'avez pas eu de réunion depuis un moment"
    },
    "calendar_view": {
      "all": "Tout",
      "select_all": "Tout sélectionner",
      "tasks": "Tâches",
      "external_meetings": "Réunions externes",
      "key_activities": "Activités clés",
      "task_tooltip": "tâche"
    },
    "contact_table": {
      "show_less": "Afficher moins",
      "show_more": "Afficher plus"
    },
    "key_activity": {
      "view_activity_details": "voir les détails de l'activité",
      "activity": "Activité",
      "type": "Type",
      "note": "Note",
      "edit_activity": "Modifier l'activité",
      "remove": "Supprimer"
    }
  },
  "company_list": {
    "show_personal_info": "Afficher les informations personnelles",
    "close_personal_info": "Fermer les informations personnelles"
  },
  "reports": {
    "search_placeholder": "Rechercher un rapport",
    "loading": "Chargement des rapports",
    "loading_report": "Chargement du rapport",
    "empty_state": "Aucun rapport disponible",
    "browser_not_supported": "Votre navigateur ne prend pas en charge les iframes."
  },
  "employee": {
    "autocomplete": {
      "no_options_text": "commencez à taper pour rechercher des employés",
      "all_option": "Tous"
    },
    "engagement": {
      "relationship_partner": {
        "title": "Partenaire Relationnel",
        "description": "Toutes les entreprises où cet employé est un partenaire relationnel"
      },
      "top_companies": {
        "title": "Top 10 des Entreprises",
        "description": "Top 10 des entreprises par nombre d'interactions"
      },
      "top_contacts": {
        "title": "Top 10 des Contacts",
        "description": "Top 10 des contacts par nombre d'interactions"
      },
      "table_headers": {
        "company": "Entreprise",
        "opportunities": "Opportunités",
        "partners": "Partenaires",
        "type": "Type",
        "engagement": "Engagement",
        "industry": "Industrie",
        "internal_industry": "Industrie Interne",
        "contact": "Contact",
        "interactions_count": "# d'Interactions",
        "who_knows": "Qui Connaît"
      }
    }
  },
  "hierarchy": {
    "slide": {
      "title": "Hiérarchie d'entreprise",
      "loading_aria_label": "chargement de la hiérarchie d'entreprise",
      "errors": {
        "cannot_move": "Impossible de déplacer l'entreprise :",
        "problem_showing": "Problème d'affichage de la hiérarchie :"
      }
    },
    "view": {
      "dense_view": "Vue dense",
      "view_hierarchy": "Voir la hiérarchie d'entreprise",
      "companies_count": "Entreprises :"
    },
    "info": {
      "last_interaction": "Dernière interaction"
    },
    "actions": {
      "add_child_company": "ajouter une nouvelle entreprise enfant sous",
      "update_fields": "Mettre à jour les champs",
      "update_field": "mettre à jour le champ",
      "hide_children": "Masquer les entreprises enfants de",
      "show_children": "Afficher les entreprises enfants de"
    },
    "removal": {
      "confirmation_title": "Êtes-vous sûr ?",
      "confirmation_content": "Cliquez sur confirmer pour retirer l'entreprise de la hiérarchie. Vous pouvez toujours la rajouter plus tard",
      "remove_label": "Retirer {{companyName}} de la hiérarchie"
    },
    "placement": {
      "title": "Placement",
      "table": {
        "headers": {
          "contact": "Contact",
          "company": "Entreprise",
          "location": "Localisation",
          "actions": "Actions"
        },
        "changed_company": "Entreprise changée",
        "ignore_contact": "ignorer le contact",
        "add_to_hierarchy": "ajouter à la hiérarchie"
      },
      "ignore": {
        "confirmation_title": "Ignorer le contact ?",
        "confirmation_content": "Cette action supprimera définitivement le contact de cette liste.",
        "label": "ignorer"
      }
    },
    "contacts": {
      "move_in_hierarchy": "Déplacer les contacts dans la hiérarchie",
      "move_contacts": "Déplacer les contacts",
      "select_company": "Sélectionner une entreprise",
      "company_placeholder": "Entreprise",
      "create_new_company": "Créer une nouvelle entreprise ici"
    },
    "company_creation": {
      "modal_title": "Créer une nouvelle entreprise",
      "create_link": "créer une nouvelle entreprise ici",
      "submit_button": "Ajouter",
      "domain_label": "Quel domaine email les contacts de cette entreprise utilisent-ils ?",
      "domain_placeholder": "Domaine email",
      "domain_caption": "Tapez le domaine email que les contacts de cette entreprise utiliseront. Laissez vide s'il utilise le même que l'entreprise actuelle.",
      "name_label": "Quel est le nom de l'entreprise ?",
      "name_placeholder": "Nom de l'entreprise",
      "name_caption": "Vous pouvez changer le nom de l'entreprise à tout moment.",
      "company_domain_label": "Domaine de l'entreprise",
      "company_name_label": "Nom de l'entreprise"
    },
    "bulk_associate": {
      "add_to_hierarchy": "Ajouter une entreprise à la hiérarchie",
      "modal_title": "Ajouter une entreprise à la hiérarchie",
      "select_companies": "Sélectionner les entreprises",
      "companies_placeholder": "Entreprises",
      "if_not_exist": "Si l'entreprise n'existe pas encore,"
    },
    "validation": {
      "company_required": "L'entreprise est requise",
      "company_name_required": "Le nom de l'entreprise est requis",
      "select_one_company": "veuillez sélectionner au moins une entreprise",
      "enter_company_name": "veuillez entrer un nom d'entreprise"
    }
  }
}
